// @TODO move to yi-core config
export const GRAPHQL_URL = process.env.GATSBY_GRAPHQL_URL || 'http://localhost:4000/graphql';
